import { Checkbox, Text } from "@fluentui/react-components";
import { useAtom, useAtomValue } from "jotai";
import { selectedCategoryFilterAtom } from "store";
import { benefitContentTabAtom } from "store/UIBenefitsPage";

import { Flex } from "components/styled";

type Props = {
  id: string;
  name: string;
};

export function CategoryFilterItem({ id, name }: Props) {
  const [categoryFilters, setSelectedCategoryFilters] = useAtom(selectedCategoryFilterAtom);
  const selectedContentTab = useAtomValue(benefitContentTabAtom);

  const isFiltered = categoryFilters[selectedContentTab]?.find((item) => item.id === id);

  return (
    <Flex key={id}>
      <Checkbox
        checked={!!isFiltered}
        onChange={(_, data) => {
          const checked = data.checked;

          if (checked) {
            setSelectedCategoryFilters((prev) => {
              return {
                ...prev,
                [selectedContentTab]: [...(prev[selectedContentTab] || []), { id, name }],
              };
            });
          } else {
            setSelectedCategoryFilters((prev) => {
              return {
                ...prev,
                [selectedContentTab]: prev[selectedContentTab].filter((item) => item.id !== id),
              };
            });
          }
        }}
      />
      <Text>{name}</Text>
    </Flex>
  );
}
